import { z } from 'zod';
import { ProspectDto } from '@zaplify/prospects';
import { createToolSignature } from './tool-signature';
import { ProspectSimplifiedSchema } from '../schemas/prospect.schema';

export const getProspectsInfoToolSignature = createToolSignature({
    name: 'getProspectsInfoTool',
    description:
        'Get the complete info about contacts corresponding to the given prospectIds (information includes current job position, previous experiences, Linkedin Profile Summary, and more). Can optionally display the list of contacts to the user if the user wishes to add them to a playbook in Andsend.',
    inputSchema: z.object({
        prospectIds: z.array(z.string()).describe('The prospectIds of the contacts to get the info for.'),
    }),
    outputSchema: z.object({
        prospects: z.array(ProspectSimplifiedSchema),
    }),
    toolCallUi: (input) => `Getting info about contacts`,
});
